<template lang="pug">
.k-tour-rewards.brand-dark-blue.relative
  k-container
    v-row(align="center")
      v-col(xl="5" lg="6" md="6" sm="7" cols="12").white--text
        .k-tour-rewards__title.title--semi-large.mb-5.font-weight-bold.font-family--secondary Earn Free Kintell Time
        .paragraph.mb-10.faded--8 Join Kintell Rewards, by inviting your friends and colleagues to Kintell, and for every person that joins up you’ll earn free time (we call it Pro Bono) to spend on Kintell. It’s quick and easy!
        .pb-10
          div(v-for="point in points")
            .d-inline-flex.align-center.pb-1
              k-icon(size="15").pr-10 check
              .white--text.paragraph {{ point }}
        k-button(v-if="userIsAuthenticated" color="primary" to="/my-kintell/my-rewards" responsive).ma-0 Send out invites now
        k-button(v-else color="primary" to="/join-now" responsive).ma-0 join kintell now
      v-col(xl="7" lg="6" md="6" sm="5" cols="12")
        v-img(:src="birdHoldingMail" height="200" width="400" contain).k-tour-rewards__image.hidden-xs-only
</template>

<script>
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [ UsesAuthenticatedUser ],
  data () {
    return {
      birdHoldingMail: require('~images/bird-holding-mail.svg'),
      birdHoldingMailMobile: require('~images/bird-holding-mail-mobile.svg'),
    }
  },
  computed: {
    points () {
      return [
        'Earn up to 100 hours of Pro Bono credit',
        '30 minutes of free time for advisor sign ups',
        'Spend Pro Bono credit on Kintell bookings'
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.k-tour-rewards {
  overflow: hidden;

  padding: 50px 0;

  @include sm-and-down {
    padding: 10px 0;
  }

  &__image {
    height: 100% !important;
    max-width: 500px;
    position: absolute;
    right: 10%;
    top: 0;
    width: 40% !important;

    @include sm-and-down {
      left: 0;
      max-width: 100%;
      position: relative;
      width: 100% !important;
    }
  }
}
</style>

